// lib/schemas/authSchema.ts
import { z } from "zod";

// Reuse password rule for registration
const passwordSchema = z
  .string()
  .min(8, "Password must be at least 8 characters")
  .regex(/[a-zA-Z]/, "Password must contain a letter")
  .regex(/[0-9]/, "Password must contain a number");

// Register Schema (unchanged)
export const registerSchema = z
  .object({
    intent: z.enum(["unsure", "new"]),
    flowType: z.literal("account"),
    role: z.enum(["manufacturer", "distributor", "recycler", "homeowner"]),
    name: z.string().min(1, "Full name is required"),
    email: z.string().email("Invalid email address"),
    phone: z.string().min(10, "Phone number is too short"),
    password: passwordSchema,
    confirmPassword: z.string().min(1, "Confirm password is required"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });

// Updated Login Schema
export const loginSchema = z.object({
  email: z.string().email("Invalid email address"),
  password: z.string().min(1, "Password is required"),
});

// Add a helper to normalize role for backend
// export const normalizeRole = (role: string): "USER" | "MANUFACTURER" | "DISTRIBUTOR" | "RECYCLER" => {
//   switch (role) {
//     case "homeowner":
//       return "USER";
//     case "manufacturer":
//       return "MANUFACTURER";
//     case "distributor":
//       return "DISTRIBUTOR";
//     case "recycler":
//       return "RECYCLER";
//     default:
//       throw new Error("Invalid role");
//   }
// };

// Types
export type RegisterFormData = z.infer<typeof registerSchema>;
export type LoginFormData = z.infer<typeof loginSchema>;
